(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbContentTypeGroupConfig', [ContentTypeGroupConfigDirective])
		.controller('ContentTypeGroupConfigController',
		[
			'$http',
			'$q',
			'$state',
			'gettextCatalog',
			'pxProgressService',
			'sbToastService',
			'smbSortService',
			'smbContentTypeGroupConfigDataStore',
			'smbToolbarService',
			'smbIndexTypesDataTypes',
			'smbContentTypeGroupTagTypesConfigDataStore',
			ContentTypeGroupConfigController
		]);

	var templateUrl = require('./contentTypeGroupConfig.template');
	function ContentTypeGroupConfigDirective() {
		return {
			restrict: 'E',
			controller: ContentTypeGroupConfigController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				groupId: '@'
			}
		};
	}

	function ContentTypeGroupConfigController(
		$http,
		$q,
		$state,
		gettextCatalog,
		pxProgressService,
		sbToastService,
		smbSortService,
		smbContentTypeGroupConfigDataStore,
		smbToolbarService,
		smbIndexTypesDataTypes,
		smbContentTypeGroupTagTypesConfigDataStore
	) {
		var vm = this;
		var title = vm.groupId ? gettextCatalog.getString('Edit Document Group') : gettextCatalog.getString('Create Document Group');
		smbToolbarService.set(title, 'contentConfig.groups');

		vm.loading = false;
		vm.onSubmit = onSubmit;

		/*** Group related properties ***/
		vm.group = null;
		vm.viewRightsUserGroups = [];
		vm.fullRightsUserGroups = [];
		vm.editRightsUserGroups = [];
		vm.groupIsDirty = false;
		vm.onGroupChange = onGroupChange;

		/*** Index type related properties ***/
		vm.indexTypes = [];
		vm.indexTypePool = [];
		var newIndexTypes = [];
		var editIndexTypes = [];
		vm.indexTypesAreDirty = false;
		vm.newIndexType = newIndexType;
		vm.editIndexType = editIndexType;

		var sortIndexTypesByName = smbSortService.sortObjectByStringProperty('TagTypeName');

		/*** Controller initialization ***/
		(function initContentTypeGroupConfigController() {
			vm.groupIsDirty = false;
			vm.indexTypesAreDirty = false;

			vm.loading = true;
			pxProgressService.visible = true;
			smbContentTypeGroupConfigDataStore
				.getContentTypeGroup(vm.groupId)
				.then(function() {
					vm.group = Object.assign({}, smbContentTypeGroupConfigDataStore.contentTypeGroup);
					vm.viewRightsUserGroups = smbContentTypeGroupConfigDataStore.userGroupsWithViewRights.map(function(ug) { return Object.assign({}, ug); });
					vm.fullRightsUserGroups = smbContentTypeGroupConfigDataStore.userGroupsWithFullRights.map(function(ug) { return Object.assign({}, ug); });
					vm.editRightsUserGroups = smbContentTypeGroupConfigDataStore.userGroupsWithEditRights.map(function(ug) { return Object.assign({}, ug); });
				})
				.then(function() {
					return smbContentTypeGroupTagTypesConfigDataStore.getTagTypes(vm.groupId);
				})
				.then(function() {
					vm.indexTypes = smbContentTypeGroupTagTypesConfigDataStore.tagTypes.map(function(tt) {
						return Object.assign({}, tt, {
							Constraints: Object.assign({}, tt.Constraints)
						});
					});

					vm.indexTypes.sort(sortIndexTypesByName);
				})
				.finally(function() {
					vm.isLoading = false;
					pxProgressService.visible = false;
				});
		}());

		function onSubmit() {
			vm.loading = true;
			pxProgressService.visible = true;
			if (vm.group && vm.group.LibraryName && vm.group.IconName) {
				saveGroup()
				.then(function() {
					return saveUserGroups();
				})
				.then(function() {
					return saveIndexTypes();
				})
				.then(function() {
					$state.go('contentConfig.groups');
					var message = vm.groupId ? gettextCatalog.getString('Document group saved!') : gettextCatalog.getString('Document group created!');
					sbToastService.showSimple(message);
				})
				.catch(function(e) {
					if (e.status === 409) {
						var message = gettextCatalog.getString('"{{documentGroupName}}" document group already exists!', { documentGroupName: vm.group.LibraryName });
						sbToastService.showSimple(message);
					} else if (typeof e.data === 'string' && e.status !== 500) {
						sbToastService.showSimple(e.data);
					} else {
						sbToastService.showSimple(gettextCatalog.getString('An unknown error has occurred'));
					}
				})
				.finally(function() {
					vm.loading = false;
					pxProgressService.visible = false;
				});
			}
		}

		function saveGroup() {
			if (vm.groupIsDirty) {
				var p;
				if (vm.groupId) {
					p = smbContentTypeGroupConfigDataStore.saveContentTypeGroup({
						id: vm.groupId,
						name: vm.group.LibraryName,
						icon: vm.group.IconId
					});
				} else {
					p = smbContentTypeGroupConfigDataStore.saveContentTypeGroup({
						name: vm.group.LibraryName,
						icon: vm.group.IconId
					});
				}
				return p;
			} else {
				return $q.resolve(vm.group);
			}
		}

		function saveUserGroups() {
			if (vm.groupIsDirty) {
				return smbContentTypeGroupConfigDataStore.saveUserGroups(vm.viewRightsUserGroups, vm.fullRightsUserGroups, vm.editRightsUserGroups);
			} else {
				return $q.resolve(vm.viewRightsUserGroups.concat(vm.fullRightsUserGroups).concat(vm.editRightsUserGroups));
			}
		}

		function saveIndexTypes() {
			if (vm.indexTypesAreDirty) {

				var newPromises = newIndexTypes.map(function(tt) {
					return smbContentTypeGroupTagTypesConfigDataStore.addTagType(smbContentTypeGroupConfigDataStore.contentTypeGroup.LibraryId, tt);
				});

				var editPromises =  editIndexTypes.map(function(tt) {
					return smbContentTypeGroupTagTypesConfigDataStore.editTagType(smbContentTypeGroupConfigDataStore.contentTypeGroup.LibraryId, tt);
				});

				return $q.all(newPromises.concat(editPromises));
			} else {
				return $q.resolve(vm.indexTypes);
			}
		}

		/*** Group Config Form component event handlers ***/

		/**
		 * Possible Arguments:
		 * group - The content type group object in the group form component
		 * viewUserGroups - The view rights user groups list in the group form component
		 * fullUserGroups - The full rights user groups list in the group form component
		 */
		function onGroupChange() {
			vm.groupIsDirty = true;
		}

		/*** Index Types Config component event handlers ***/

		function editIndexType(indexType) {
			vm.indexTypesAreDirty = true;
			vm.indexTypes = vm.indexTypes.map(function(x) {
				return x.TagTypeName === indexType.TagTypeName ? angular.extend({}, x, indexType) : x;
			});
			if (indexType.TagTypeId) {
				// this is an existing tag type, keep track of it via the editIndexTypes array
				editIndexTypes.push(indexType);
			}
		}

		function newIndexType(indexType) {
			vm.indexTypesAreDirty = true;
			vm.indexTypes = vm.indexTypes.concat([indexType]);
			vm.indexTypes.sort(sortIndexTypesByName);
			newIndexTypes.push(indexType);
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/contentTypeGroupConfig/contentTypeGroupConfig.js
// module id = 68
// module chunks = 1